<!-- 连续型电子出版物 -->

<template>
  <div class="press-4">
    <MainTabs
      v-if="wSat == 1"
      :cancelFlag="cancelFlag"
      :pressType="typeLst"
      :pressDat="resDat"
      role="press"
      :organization="organization" />
  </div>
</template>

<script>
import MainTabs from "@/views/components/SPEC/SpecCommonTab";
import { getPressList } from "@/api/pressRole/pressRole";
export default {
  components: {
    MainTabs,
  },
  data() {
    return {
      wSat: 0,
      typeLst: "",
      organization: "",
      resDat: [{}],
      cancelFlag: false,
    };
  },
  created: function () {
    this.organization = this.$store.getters.name;
    this.typeLst = this.$route.query.pressType;

    let vm = this;
    const loading = vm.$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    getPressList({
      type: this.$route.query.pressType,
      // zym.20241212，增加年份
      year: this.$route.query.firstYear,
    })
      .then((response) => {
        loading.close();
        vm.wSat = 1;
        // console.log("response.cancelFlag=", response.cancelFlag);
        // console.log(typeof response.cancelFlag);
        // console.log(typeof this.$route.query.cancelFlag);
        if (this.$route.query.cancelFlagStr) {
          vm.cancelFlag = this.$route.query.cancelFlagStr == "true";
        } else {
          vm.cancelFlag = response.cancelFlag;
        }

        this.resDat.splice(0, 1, response);
      })
      .catch(() => {
        loading.close();
      });
  },
};
</script>

<style lang="scss">
.press-4 {
  padding: 0px 12px;
  margin-bottom: 30px;

  .subLine {
    text-align: center;
    margin: 0px 0px 50px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .succedTips {
    font-size: 14px;
    color: #666666;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// skimFrame.vue?e18e1b50